import React, { useEffect, useState } from 'react';
import map from 'lodash/map';
import max from 'lodash/max';
import uniq from 'lodash/uniq';

import { getPaymentVendorInterestFreeList } from '../../graphql/payment-vendor-interest-free-list.2';
import {
  GetPaymentVendorInterestFreeList_payment_vendor_interest_free_list_item_list as VendorInterestItem,
  VendorType,
} from '../../graphql/payment-vendor-interest-free-list_types.2';
import { InterestFreeView } from './InterestFreeView';

export interface PaymentProps {
  financial_company_code: string;
  installment_month_list: number[];
  min_amount: number;
}

export const InterestFree = () => {
  const [financialCompanyList, setFinancialCompanyList] = useState<PaymentProps[]>([]);
  useEffect(() => {
    const reqFinancialCompanyList = async () => {
      const {
        data: { payment_vendor_interest_free_list },
      } = await getPaymentVendorInterestFreeList();

      const financial_company_code_list = uniq(
        map(payment_vendor_interest_free_list.item_list, (o) => o.financial_company_code),
      );

      const findSameMonth = (list: VendorInterestItem[], month: number) => {
        return list.find((item) => {
          if (item.installment_month === month) {
            return month;
          }
        });
      };

      const effective_list: PaymentProps[] = financial_company_code_list.map((code) => {
        const list = payment_vendor_interest_free_list.item_list.filter((o) => o.financial_company_code === code);
        const min_amount = max(map(list, (o) => o.min_amount)) ?? 0;
        const uniq_vendor_type_list = uniq(map(list, (o) => o.vendor_type));
        const uniq_installment_month_list = uniq(map(list, (o) => o.installment_month));
        const single_vendor_type = uniq_vendor_type_list.length === 1;

        let installment_month_list: number[] = [];

        if (single_vendor_type) {
          installment_month_list = uniq_installment_month_list;
        } else {
          const list_filter_vendor = {} as Record<VendorType, VendorInterestItem[]>;

          uniq_vendor_type_list.forEach((vendor_type) => {
            list_filter_vendor[vendor_type] = list.filter((item) => item.vendor_type === vendor_type);
          });

          const valid_month_list = uniq_installment_month_list
            .map((month) =>
              uniq_vendor_type_list
                .map((vendor_type) => findSameMonth(list_filter_vendor[vendor_type], month))
                .filter(Boolean)
                .map((i) => i?.installment_month),
            )
            .filter((i) => i.length === uniq_vendor_type_list.length);

          valid_month_list.forEach((month) => month?.length && month[0] && installment_month_list.push(month[0]));
        }

        return {
          financial_company_code: code,
          installment_month_list,
          min_amount,
        };
      });

      setFinancialCompanyList(effective_list);
    };
    reqFinancialCompanyList();
  }, []);

  return <InterestFreeView financialCompanyList={financialCompanyList} />;
};
